<h4 *ngIf="edit">Edit Form /{{item.name}}/{{item.id}}/</h4>
<form (ngSubmit)="save()" #itemForm="ngForm">
    <div class="item-panel" style ="margin-top: 0px;">
        <div class="p-grid">
            <div class="p-fluid p-md-6">
                <div class="p-field">
                    <label for="name">Nom *</label>
                        <input type="text" size="30" pInputText name="name" id="name"  readonly="true" pattern="[\D]{3,50}" 
                               [required]="true" maxlength="50" minlength="3" autocomplete="off" [(ngModel)]="item.name"> 
                    <p-message severity="error" 
                               [text]="itemForm.controls['name'].errors['required'] ? 'name is required' : itemForm.controls['name'].errors['maxlength'] ? 'Must be smaller than 150 characters' : ''"
                               *ngIf="!itemForm.controls['name']?.valid&&itemForm.controls['name']?.dirty"></p-message>
                </div>
                <div class="p-field">
                    <label for="float-input">Description *</label>
                        <textarea size="30" pInputTextarea name="description"  readonly="true"
                                  [required]="false" maxlength="1000" autocomplete="off" [(ngModel)]="item.description"></textarea> 

                    <p-message severity="error" 
                               [text]="itemForm.controls['description'].errors['required'] ? 'description is required' : itemForm.controls['description'].errors['maxlength'] ? 'Must be smaller than 1000 characters' : ''"
                               *ngIf="!itemForm.controls['description']?.valid&&itemForm.controls['description']?.dirty"></p-message>
                </div>
                <div class="p-field">
                    <label for="name">Process *</label>
                    <input type="text" size="30" pInputText name="process" readonly="true" id="process" pattern="[\D]{3,50}" 
                           [required]="true" maxlength="50" minlength="3" autocomplete="off" [value]="item.processId?.name"> 
                </div>
            </div>
            <div class="p-fluid p-md-6">
                <div class="p-field">
                        <label>Roles *</label>
                        <p-listbox [listStyle]="{'height':'150px'}" name="roleIds"
                                   [options]="roles" [(ngModel)]="item.roleIds" optionLabel="name" 
                            filter="filter" multiple="true" checkbox="true" dataKey="id">                       
                        <p-footer>
                            <div class="p-col p-col-fixed">
                                <p-tag *ngFor="let r of getSelectedGroups(item.roleIds)" styleClass="p-mr-2" [value]="r.name"></p-tag>
                            </div>
                        </p-footer>
                        </p-listbox>
                </div>
            </div>
        </div>
        <div class="ui-g">
            <div class="ui-g-4">
                <button pButton [disabled]="!itemForm.valid" type="submit" label="Validate" icon="pi pi-check" iconPos="left" style="margin-right: 0.5em;" class="pi-button-success"></button>
                <button pButton routerLink="/admin/forms"  type="button" label="Cancel"  icon="pi pi-times" iconPos="left" style="margin-right: 0.5em;" class="pi-button-danger"></button>
            </div>
        </div>
    </div>
</form>

